import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {List} from 'pages/withAuth/adminPage/systemAnnounces/List/List'
import {Show} from 'pages/withAuth/adminPage/systemAnnounces/Show/Show'

export const SystemAnnouncesRoutes: RouteParams[] = [
  {
    key: 'systemAnnounces',
    path: WITH_AUTH_ADMIN_PATHS.SYSTEM_ANNOUNCES.LIST,
    component: List,
    exact: true,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
  {
    key: 'systemAnnounces/:id',
    path: WITH_AUTH_ADMIN_PATHS.SYSTEM_ANNOUNCES.SHOW,
    component: Show,
    whiteList: ['full_admin', 'office_admin', 'limited_admin'],
  },
]
